export default "__VITE_ASSET__BlrjEUij__"